import { Grid2 } from '@mui/material';
import SideNav from '../Komponenten/Sidenav';
import Header from '../Komponenten/Header';
import Ansprechpartner from '../Komponenten/Ansprechpartner';
import News from '../Komponenten/News';
import { Hashtag } from '../Komponenten/Hashtag';
import './Startseite.css';

export default function Startseite() {
    return (
        <>
            <SideNav />
            <Grid2 container padding={5} spacing={4}>
                <Grid2 size={12} display="flex" justifyContent="center" alignItems="center" >
                    <Header />
                </Grid2>
                <Grid2 size={12} display="flex" justifyContent="center" alignItems="center">
                    <div className="welcome-text">
                        <strong><Hashtag text="#DJK.MeinVerein" /> – Herzlich Willkommen!</strong> <br/><br/>Wir sind ein Durlacher Traditionsverein mit dem Fokus auf Fußball. Im Mittelpunkt der Vereinsarbeit stehen der Kinder- und Jugendfußball. Unser Fokus liegt auf der Ausbildung und Entwicklung – vom Jugend-Spieler bis hin zum Spieler in unserer jungen Ersten Herrenmannschaft. Wir sind Stolz auf unsere über 100-jährige Vereinsgeschichte und gehen mit Zuversicht und modernen Konzepten in die Zukunft.
                        <br/><br/>
                        <strong><Hashtag text="#Teamgeist" /> <Hashtag text="#Mut" /> <Hashtag text="#Respekt" /> <Hashtag text="#Leidenschaft" /></strong> <br/><br/> Das sind unsere Werte, dafür setzen wir uns ein. Als Verein fühlen wir uns tief verwurzelt und verbunden mit unserem lebenswerten Durlach. Wir engagieren uns aktiv für die Kinder und Jugendlichen in Durlach, dazu gehören diverse Kooperationen mit Durlacher Kindergärten und Schulen. Wir organisieren den Durlacher schoolCup und bieten seit 2010 die beliebten DJK FußballCamps als Ferienfreizeit an.
                        <br/><br/>Kommen Sie vorbei und lernen Sie uns kennen. <br/><br/>
                        <strong><Hashtag text="#DJK.MeinVerein" /></strong>
                    </div>
                </Grid2>
                <Grid2 size={12} display="flex" justifyContent="center" alignItems="center">
                    <News />
                </Grid2>
                <Grid2 size={12} display="flex" justifyContent="center" alignItems="center">
                    <div
                        class="fussballde_widget"
                        data-id="153e32d7-f35e-4bbd-9dee-5df36f5b2f34"
                        data-type="club-matches">
                    </div>
                </Grid2>
                <Grid2 size={12}  >
                    <Ansprechpartner />
                </Grid2> 
            </Grid2>
        </>
    );
} 